const getProperty = (obj, prop) => prop.split('.').reduce((object, manyKey) => {
  if (object[manyKey]) {
    return object[manyKey];
  }
  return object;
}, obj);

export default getProperty;
